function getOperationTypeId(data) {
  const dataIDs = [];
  data.map(d => dataIDs.push(d.operation_type));
  return dataIDs;
}

export { getOperationTypeId };
